<template>

<main class="py-12 space-y-12">
        <section>
            <div class="container">
                <article class="dp-article">
                    <div class="article-text">
                      <h2 class="title">
                            Unsere Fertigung im Video
                      </h2>
                        <div class="grid lg:grid-cols-2 gap-8">
                            <div class="dp-video js-fade-in is-added is-visible">
                                <VideoPlayer
                                    url="/videos/Sauerland2025_Produktion_720p.mp4"
                                    name="Sauerland2025_Produktion1"
                                />
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </section>

        <section>
            <div class="container">
                <article class="dp-article">
                    <div class="article-text js-fade-in lg:columns-2 is-added is-visible">
                      <h2 class="title">
                            Unser Holz
                      </h2>
                        <p class="article-teaser">
                            Unserer Umwelt zuliebe greifen wir auf den nachwachsenden Rohstoff Holz zurück.
                        </p>
                        <p>
                            Holz, das wir aus&nbsp;den heimischen, nachhaltig bewirtschafteten Forsten beziehen und bis
                            zur Verfeuerung der Schnittabfälle komplett verwerten.&nbsp;Wir verwenden ausschließlich
                            Hölzer aus PEFC/FSC zertifizierten Waldbeständen!
                        </p>
                        <p>
                            Wegen ihrer überragenden Eigenschaften verarbeiten wir hauptsächlich Hölzer aus&nbsp;
                            kerngetrennter und&nbsp;naturbelassener Douglasie. Sie härtet hervorragend aus, ist
                            resistent, hat herausragende statische Eigenschaften und lässt sich sehr gut form- und
                            kraftschlüssig verarbeiten.&nbsp;<br>
                            <br>
                            Die Auswahl der einzuschlagenden Bäume erfolgt durch unsere qualifizierten Holzmeister
                            gemeinsam mit den Forstwirten. Dadurch gewährleisten wir eine gleichbleibende Qualität der
                            Hölzer und minimieren Ausschuss und Verschnitt schon vor dem Einschlag der Bäume.
                        </p>
                    </div>
                </article>
            </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-5 gap-16">
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="wintereingeschlagene_Hoelzer.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h3>
                        Wir verwenden nur wintereingeschlagene Hölzer für beste Qualität!
                  </h3>
                    <p>
                        Bäume werden am besten zwischen Dezember und Anfang Februar gefällt. Dann fließt in den Adern
                        weniger Wasser als während der Wachstumsperiode und es sind geringere Mengen an Mineralien
                        vorhanden. Durch die geringere Winterholzfeuchte und Freiluftlagerung verläuft der
                        Trocknungsvorgang schonender als beim Sommereinschlag mit Kammertrocknung.
                    </p>
                </div>

                <div class="lg:col-span-3">
                  <h3>
                        Das Holz wird kernfrei eingeschnitten
                  </h3>
                    <p>
                        Durch den kernfreien Einschnitt weisen die Hölzer wesentlich weniger und kleinere Risse auf und
                        drehen sich nicht so stark wie kernhaltige oder kerngetrennte Hölzer.
                    </p>
                </div>
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="kernfreier_Einschnitt.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>

                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Hobeln2.png"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h3>
                        Wir hobeln die benötigten Hölzer und Querschnitte selber
                  </h3>
                    <p>
                        Und können so bereits frühzeitig Qualitäten in Bezug auf Asthaltigkeit (Menge und Größe),
                        Rissbildung und Gesamtzustand des Holzes vor der Weiterverarbeitung sortieren.
                    </p>
                    <p>
                        Kleinere Äste werden ausgebohrt und durch einen mit dem Faserverlauf
                        ausgerichteten, verleimten Holzdübel ersetzt.
                    </p>
                </div>
            </div>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C6323neu.jpg);"
        >
          <span class="noprint"/>
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Verarbeitung und Produktion
                </h2>
            </div>
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section class="container dp-contentblock block-default">
            <div class="dp-pagebounds">
                <article class="dp-article">
                  <div class="article-text js-fade-in lg:columns-2 gap-12 is-added is-visible">
                    <h3 class="title">
                            So geht's in der Produktion zu!
                    </h3>
                        <p class="article-teaser">
                            Hier erfahren Sie wie wir bei Sauerland Spielgeräte unser Holz verarbeiten. Darunter fallen
                            der Mantelschliff, die Plattenbearbeitung und was wir mit unseren Resten machen.
                        </p>
                        <p>
                            Durch die maschinelle Bearbeitung können wir gleichbleibende und passgenaue Bauteile, sowie
                            Ersatzteile für Ihre Spielgeräte fertigen. Dadurch verlängern wir die Lebensdauer Ihres
                            Spielplatzes!<br>
                            Für alle Geräte ab dem Baujahr 2008 können wir Ihnen anhand der Plakettennummer Ihres
                            Gerätes alle&nbsp;Bauteile passgenau reproduzieren.
                        </p>
                        <p><strong>Das spart Ihnen Zeit und Geld!</strong></p>
                    </div>
                </article>
            </div>
        </section>

        <section class="container dp-contentblock block-textimage ">
            <article class="dp-article">
                <div class="dp-pagebounds">
                    <div class="grid lg:grid-cols-5 gap-16">
                        <div class="lg:col-span-3 article-text js-fade-in is-added is-visible">
                          <h4 class="h3">Mantelschliff</h4>
                            <p>
                                Alle Hölzer erhalten nach der Fertigung einen Mantelschliff. Nach dem Hobeln können
                                sich durch Feuchtigkeitsaufnahme kleinere Fasern wieder aufstellen. Um die homogene
                                Oberfläche und optimale Haptik zu gewährleisten, schleifen wir alle Bauteile
                                nach.
                            </p>
                        </div>
                        <div class="lg:col-span-2">
                            <NuxtPicture
                                class="js-fade-in is-added is-visible"
                                src="Mantelschliff.png"
                                alt=""
                                :img-attrs="{ class: 'rounded-lg' }"
                            />
                        </div>

                        <div class="lg:col-span-2">
                            <NuxtPicture
                                class="js-fade-in is-added is-visible"
                                src="Bildschirmfoto-2020-11-27-um-08.38.png"
                                alt=""
                                :img-attrs="{ class: 'rounded-lg' }"
                            />
                        </div>
                        <div class="lg:col-span-3 article-text js-fade-in is-added is-visible">
                          <h4 class="h3">Plattenware CNC Plattenbearbeitung und Lager</h4>
                            <p>
                                Die computergesteuerte CNC optimiert die Position der Frästeile und verringert dadurch
                                den Verschnitt. Ein vollautomatisches Plattenlager lagert auch Teile von Platten wieder
                                ein, wenn diese nicht komplett verarbeitet werden, und speichert die Größe um eine
                                Ressourcen schonende Ausnutzung und ein optimales Preis-Leistungsverhältnis für Sie zu
                                erzielen.
                            </p>
                            <p class="font-bold">
                                Zudem vermeiden wir so auch unnötigen Abfall!
                            </p>
                        </div>
                    </div>
                </div>
            </article>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C1710.jpg);"
        >
          <span class="noprint"/>
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Metall
                </h2>
            </div>
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-5 gap-16">
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Metallbearbeitungszentrum1.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h3>CNC gesteuerte Bohranlage für Metallpfosten</h3>
                    <p>
                        Die notwendigen Bohrungen werden aus den Zeichnungen ausgelesen und direkt an die Bohranlage
                        übermittelt. Ausmessen, Winkel bestimmen und anzeichnen entfallen hierdurch; wir reduzieren
                        Bearbeitungszeiten und können dadurch den Preis attraktiv gestalten.
                    </p>
                    <p class="font-bold">
                        Präzise Metallbearbeitung!
                    </p>
                </div>

                <div class="lg:col-span-3">
                  <h3>Schweissen</h3>
                    <p>
                        Wir verarbeiten in unserem Metallbau Aluminium, Stahl und Edelstähle. Die Metalle werden per MAG
                        und WIG geschweißt. Unsere Mitarbeiter sind ausgebildete Schweißer und wiederholen alle 2 Jahre
                        ihre Schweißprüfung. Biege-, Kant- und Blecharbeiten führen wir ebenfalls in unserer Werkstatt
                        durch.
                    </p>
                </div>
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Bildschirmfoto-2020-11-27-um-08.39.png"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>

                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Bildschirmfoto-2020-11-27-um-08.40.png"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h3>Glasperlstrahlanlage</h3>
                    <p>
                        Viele Edelstahlprodukte werden nach dem Schweißen in unserer Glasperlstrahlanlage einer
                        Oberflächenbehandlung unterzogen. Das Strahlen beseitigt mögliche Verunreinigungen und erzeugt
                        eine hochwertige satinierte Oberfläche, die sich durch Sonneneinstrahlung deutlich geringer
                        aufheizt als eine polierte Oberfläche. Das verwendete Strahlgut wird gereinigt und mehrfach
                        wiederverwendet.
                    </p>
                    <p class="font-bold">
                        Edle und widerstandsfähige Oberfläche!
                    </p>
                </div>
            </div>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C5537.jpg);"
        >
          <span class="noprint"/>
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Transport
                </h2>
            </div>
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-5 gap-16">
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Bildschirmfoto-2020-11-27-um-08.41.png"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h3>Verpackung</h3>
                    <p>
                        Für Transport und Verpackung verzichten wir fast vollständig auf Folien und
                        Kunststoffverpackungen. Wir setzen wiederverwendbare Holzpaletten ein und sichern die Geräte und
                        Module mit Umreifungsbändern.
                    </p>
                    <p class="font-bold">
                        Soviel wie nötig, so wenig wie möglich!
                    </p>
                </div>

                <div class="lg:col-span-3">
                  <h3>Tourenoptimierung</h3>
                    <p>
                        Wir planen die Auslieferung unserer Geräte computergestützt, damit wir die effizienteste Route
                        unter Berücksichtigung der Lenk- und Ruhezeiten zusammenstellen.
                    </p>
                    <p class="font-bold">
                        Den CO2 Ausstoß reduzieren wir so auf ein notwendiges Minimum.
                    </p>
                </div>
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Tourenoptimierung.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
            </div>
        </section>

        <section
            class="relative bg-cover bg-center dp-contentblock block-title py-largest dp-fsimg"
            style="background-image: url(/images/backgrounds/BQ4C1368-1.jpg);"
        >
          <span class="is-amber noprint"/>
            <div class="relative z-10 py-48 dp-pagebounds">
              <h2 class=" my-none py-large py-l-largest text-center text-white! js-fade-in is-added is-visible">
                    Montage
                </h2>
            </div>
          <div class="absolute top-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" flip variant="trio"/>
          </div>
          <span class="brand-overlay is-duo is-reversed is-vertical noprint"/>
          <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
            <BrandWave :height="150" variant="trio"/>
          </div>
        </section>

        <section class="container">
            <div class="grid lg:grid-cols-5 gap-16">
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="Montage.jpg"
                        alt=""
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h3>So montieren wir Ihren Spielplatz</h3>
                    <p class="article-teaser">
                        Unsere Spielplatzgeräte werden standardmäßig modular vormontiert, mögliche Fehler beim
                        Zusammenbau werden vermieden. Sie erhalten generell eine umfangreiche Liefermappe mit
                        Montageplänen und Wartungsprotokollen!
                    </p>
                    <p>
                        Auf Wunsch planen und terminieren wir für Sie auch einen Komplett-Service: von der Lieferung
                        über die fach- und sachgerechte Montage bis hin zur sicherheitstechnischen Abnahme.
                    </p>
                    <p class="font-bold">
                        Das spart Ihnen Zeit, Kosten und Reibungsverluste und erhöht die Sicherheit.
                    </p>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
import VideoPlayer from '~/components/VideoPlayer.vue';

definePageMeta({
    path: '/Fertigung',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Kreationen',
};
</script>

<style scoped>

</style>
